import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { Employee } from '@app/models/employee/employee.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { FullNameColumn } from './columns/full-name';
import { StatusColumn } from './columns/status';

const editOption: MenuColumnItem = {
    label: 'self-serve.edit',
    event: 'edit',
};

@Injectable()
export class AddEmployeesTable extends Table {
    showMenuColumnOptions = true;

    constructor(
        protected auth: AuthService,
        protected translateService: TranslateService
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.addColumns(new FullNameColumn(), new StatusColumn(this.translateService));
    }

    getMenuColumnOptionsForRow(_: Employee): MenuColumnItem[] {
        return [editOption];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Employee.param('company', this.auth.company.id)
                .with('account')
                .where('status', ['active', 'onboarding', 'terminated', 'on leave'])
                .limit(10),
            {
                pageSize: 10,
            }
        );
    }
}
